




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IVehicle } from '@/models/Vehicle';
import { konsole } from '@/services/Konsole';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCar } from '@fortawesome/pro-solid-svg-icons';

@Component
export default class VehicleCard extends Vue {
  @Prop({ required: true }) public vehicle!: IVehicle;

  constructor() {
    super();
    library.add(faCar);
    // konsole.init('new instance of VehicleCard');
  }
}
